/*
 * Copyright (c) All right reserved Anvish Inc. 2026
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */

"use client";
import React from "react";
import { usePathname } from "next/navigation";

import NonAuthFooter from "@/components/layout/footer/NonAuthFooter";

interface RouteBasedNavbarProps {
  csrfToken: any;
  footerData: any;
}

const RouteBasedFooter: React.FC<RouteBasedNavbarProps> = ({
  csrfToken,
  footerData,
}) => {
  const currentPathName = usePathname();

  const isDashboardPage = currentPathName.startsWith("/dashboard");
  const isAuthPage = currentPathName.startsWith("/auth");

  return (
    <div>
      {!isDashboardPage && !isAuthPage && (
        <NonAuthFooter csrfToken={csrfToken} footerData={footerData} />
      )}
    </div>
  );
};

export default RouteBasedFooter;
